import ImpersonatedUserBanner from './ImpersonatedUserBanner.jsx'

export default ImpersonatedUserBanner
